import { gql } from "@outschool/ui-apollo";

import { ParentFragment } from "./ParentFragments";

// Todo, decide what needs to come from the following fragments:
// import LearnerFragment from "./LearnerFragment";

// import { SectionFragment } from "./SectionFragments";
// import EnrollmentFragment from "./EnrollmentFragment";

export default gql`
  fragment WaitlistSeatFragment on WaitlistSeat {
    uid
    createdAt
    parent {
      ...ParentFragment
    }
    learner {
      uid
      name
    }
    section {
      uid
    }
    enrollment {
      uid
    }
  }
  ${ParentFragment}
`;
